export var styles = {
    base: 'gs-input',
    disabled: 'gs-input-disabled',
    errored: 'gs-input-errored',
    container: 'gs-input-container',
    slot: 'gs-input-slot',
    slotBottom: 'gs-input-slot-b',
    slotTop: 'gs-input-slot-t',
    slotRight: 'gs-input-slot-h gs-input-slot-r',
    slotLeft: 'gs-input-slot-h gs-input-slot-l',
    slotH: 'gs-input-slot-h',
    slotC: 'gs-input-slot-c',
    slotPanel: 'gs-input-slot-panel',
    slotContentTop: 'gs-input-slot-top',
    slotContentBottom: 'gs-input-slot-bottom',
    slotContentLeft: 'gs-input-slot-left',
    slotContentRight: 'gs-input-slot-right',
    variants: {
        outlined: 'gs-input-variant-outlined',
        filled: 'gs-input-variant-filled',
        bordered: 'gs-input-variant-border',
        borderless: 'gs-input-variant-borderless',
        solo: 'gs-input-variant-solo',
    },
    sizes: {
        small: 'gs-input-size-small',
        medium: 'gs-input-size-medium',
        large: 'gs-input-size-large',
    },
    aligns: {
        left: '',
        right: 'gs-input-align-right',
        center: 'gs-input-align-center',
    },
    controls: {
        label: 'gs-input-label',
        hint: 'gs-input-hint',
        prefix: 'gs-input-prefix',
        suffix: 'gs-input-suffix',
    },
    styles: {
        inputFocused: 'gs-input-focused',
        inputErrored: 'gs-input-error',
        inputCenter: 'gs-input-center',
        inputRight: 'gs-input-right',
        inputRow: 'gs-container-input-row',
        inputCol: 'gs-container-input-col',
        inputSeparator: 'gs-container-input-separator',
    }
};
